// delivery-estimator.js (Updated 2025-10-21): Excludes Isle of Wight postcodes (PO30-PO41)
(function () {
  window.dataLayer = window.dataLayer || [];
  window.__DE_INSTANCES__ = window.__DE_INSTANCES__ || {};

  // --- Postcode helpers
  function validUK(pc) {
    var UK_POSTCODE_REGEX = /^(GIR 0AA)|((([A-Z]{1,2}[0-9][0-9A-Z]?)\s*[0-9][A-Z]{2}))$/i;
    var compact = (pc || "").trim().replace(/\s+/g, "");
    return UK_POSTCODE_REGEX.test(compact);
  }
  function normalise(pc) { return (pc || "").trim().toUpperCase().replace(/\s+/g, " "); }
  function outward(pc) { return normalise(pc).split(" ")[0]; }
  function outwardPrefix(pc) { var up = (pc || "").toUpperCase().trim(); return up.split(/\d/)[0].trim(); }

  // --- Date helpers
  function formatUK(date) {
    var dd = ("0" + date.getDate()).slice(-2);
    var mm = ("0" + (date.getMonth() + 1)).slice(-2);
    var yyyy = date.getFullYear();
    var wk = date.toLocaleDateString("en-GB", { weekday: "short" });
    return wk + ", " + dd + "/" + mm + "/" + yyyy;
  }

  // Working days & bank holidays (England & Wales, 2025 & 2026)
  var UK_BANK_HOLIDAYS = [
    // 2025
    "2025-01-01","2025-04-18","2025-04-21","2025-05-05","2025-05-26","2025-08-25","2025-12-25","2025-12-26",
    // 2026
    "2026-01-01","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-08-31","2026-12-25","2026-12-28"
  ];
  function isWorkingDay(d) {
    var day = d.getDay(); // 0 Sun, 6 Sat
    var iso = d.toISOString().split("T")[0];
    return day !== 0 && day !== 6 && UK_BANK_HOLIDAYS.indexOf(iso) === -1;
  }
  function addWorkingDays(fromDate, days) {
    var d = new Date(fromDate);
    var remaining = Number(days) || 0;
    while (remaining > 0) {
      d.setDate(d.getDate() + 1);
      if (isWorkingDay(d)) remaining--;
    }
    return d;
  }
  function workingDateRangeText(startDays, endDays) {
    var today = new Date();
    var s = addWorkingDays(today, startDays);
    var e = addWorkingDays(today, endDays);
    return formatUK(s) + " – " + formatUK(e);
  }

  // M25 Sunday service with Friday 12:00 cutoff
  function nextTwoSundaysWithCutoff(now) {
    var d = now ? new Date(now) : new Date();
    var day = d.getDay(); // 0 Sun, 5 Fri, 6 Sat
    var hours = d.getHours();
    var next = new Date(d);
    var add = (7 - day) % 7 || 7;
    next.setDate(d.getDate() + add);
    var cutoffPassed = (day === 5 && hours >= 12) || day === 6 || day === 0;
    var firstSunday = new Date(next);
    if (cutoffPassed) firstSunday.setDate(next.getDate() + 7);
    var secondSunday = new Date(firstSunday);
    secondSunday.setDate(firstSunday.getDate() + 7);
    return { firstSunday: firstSunday, secondSunday: secondSunday };
  }

  // Inside M25 outward codes
  var M25 = new Set([].concat(
    Array.from({ length: 18 }, (_, i) => "E" + (i + 1)),
    ["EC1","EC2","EC3","EC4"],
    Array.from({ length: 22 }, (_, i) => "N" + (i + 1)),
    Array.from({ length: 11 }, (_, i) => "NW" + (i + 1)),
    Array.from({ length: 28 }, (_, i) => "SE" + (i + 1)),
    Array.from({ length: 20 }, (_, i) => "SW" + (i + 1)),
    Array.from({ length: 14 }, (_, i) => "W" + (i + 1)),
    ["WC1","WC2"],
    Array.from({ length: 8 }, (_, i) => "BR" + (i + 1)),
    Array.from({ length: 10 }, (_, i) => "CR" + i),
    ["DA14","DA15","DA16","DA17","DA18"],
    ["EN1","EN2","EN3"],
    Array.from({ length: 10 }, (_, i) => "HA" + i),
    Array.from({ length: 11 }, (_, i) => "IG" + (i + 1)),
    Array.from({ length: 9 }, (_, i) => "KT" + (i + 1)),
    Array.from({ length: 20 }, (_, i) => "RM" + (i + 1)),
    Array.from({ length: 7 }, (_, i) => "SM" + (i + 1)),
    Array.from({ length: 20 }, (_, i) => "TW" + (i + 1)),
    Array.from({ length: 11 }, (_, i) => "UB" + (i + 1))
  ));
  function insideM25(pc) {
    var oc = outward(pc);
    var m = oc.match(/^[A-Z]{1,2}[0-9][0-9A-Z]?/);
    oc = m ? m[0] : "";
    return oc && M25.has(oc);
  }

  // Coverage & pricing rules
  var EXCLUDED_PREFIXES = ["BT","GY","JE","IM","KW","IV","PH","HS"];

  // NEW: Isle of Wight excluded outward codes (PO30-PO41)
  var EXCLUDED_OUTWARD_CODES = ["PO30","PO31","PO32","PO33","PO34","PO35","PO36","PO37","PO38","PO39","PO40","PO41"];

  // Prefix-based Standard price rules
  var RULES = [
    { prefixes: ["DD"], price: 150, d1: 4, d2: 14 },
    { prefixes: ["AB"], price: 150, d1: 4, d2: 14 },
    { prefixes: ["KY","FK","PA","G","KA","ML","EH","TD"], price: 75, d1: 4, d2: 14 },
    { prefixes: ["TR","CA"], price: 50, d1: 4, d2: 14 },
    { prefixes: ["TN","PL"], price: 30, d1: 7, d2: 10 },
    { prefixes: ["BN","TQ","DT","BH","PO","CO","IP","NR","NE","LA","EX","SO"], price: 25, d1: 7, d2: 10 }
  ];

  // Exact outward matches (Standard = £40, 7–10 working days)
  var PAID_LONG = [
    "CT1","CT2","CT3","CT4","CT5","CT6","CT7","CT8","CT9","CT10",
    "CT11","CT12","CT13","CT14","CT15","CT16","CT17","CT18","CT19","CT20",
    "CT21",
    "SA19","SA20","SA31","SA32","SA33","SA34","SA35","SA36","SA37","SA38",
    "SA39","SA40","SA41","SA42","SA43","SA44","SA45","SA46","SA47","SA48",
    "SA61","SA62","SA63","SA64","SA65","SA66","SA67","SA68","SA69","SA70",
    "SA71","SA72","SA73",
    "SY17","SY18","SY19","SY20","SY23","SY24","SY25",
    "LL23","LL24","LL27","LL32","LL33","LL35","LL36","LL37","LL38","LL39",
    "LL40","LL41","LL42","LL43","LL44","LL45","LL46","LL47","LL48","LL49",
    "LL51","LL52","LL53","LL54","LL55","LL56","LL57","LL58","LL59","LL60",
    "LL61","LL62","LL63","LL64","LL65","LL66","LL67","LL68","LL69","LL70",
    "LL72","LL74","LL75","LL76","LL77"
  ];

  function getPriceWindowFor(pc) {
    var up = (pc || "").toUpperCase().trim();
    var prefix = outwardPrefix(up);
    var oc = outward(up);

    // Check if outward code is specifically excluded (Isle of Wight)
    if (EXCLUDED_OUTWARD_CODES.indexOf(oc) >= 0) {
      return null; // This will trigger exclusion message
    }

    if (PAID_LONG.indexOf(oc) >= 0) return { price: 40, d1: 7, d2: 10, bucket: "£40_exact" };
    for (var i = 0; i < RULES.length; i++) {
      if (RULES[i].prefixes.some(function (p) { return prefix.indexOf(p) === 0; })) {
        return { price: RULES[i].price, d1: RULES[i].d1, d2: RULES[i].d2, bucket: "£" + RULES[i].price + "_prefix" };
      }
    }
    return { price: 0, d1: 2, d2: 7, bucket: "FREE_default" }; // default free
  }

  // Format price with decimal places
  function formatPrice(price) {
    return "£" + price.toFixed(2);
  }

  // --- Init
  function initDeliveryEstimator(root) {
    if (!root) {
      console.warn('DeliveryEstimator: No root element provided');
      return;
    }
    var sid = root.getAttribute("data-de-sid");
    if (!sid) {
      console.warn('DeliveryEstimator: No section ID found');
      return;
    }
    if (window.__DE_INSTANCES__[sid]) return window.__DE_INSTANCES__[sid];

    var form   = root.querySelector("[data-de='form']");
    var input  = root.querySelector("[data-de='input']");
    var errBox = root.querySelector("[data-de='error']");
    var errTxt = root.querySelector("[data-de='error-text']");
    var grid   = root.querySelector("[data-de='grid']");
    var meta   = root.querySelector("[data-de='meta']");
    var pcTag  = root.querySelector("[data-de='pc-tag']");

    if (!form || !input) {
      console.warn('DeliveryEstimator: Required elements not found');
      return;
    }

    var stdRange = root.querySelector("[data-de='std-range']");
    var preRange = root.querySelector("[data-de='pre-range']");
    var badgeStd = root.querySelector("[data-de='badge-standard']");
    var badgePre = root.querySelector("[data-de='badge-premier']");
    var noteStd  = root.querySelector("[data-de='note-standard']");
    var notePre  = root.querySelector("[data-de='note-premier']");
    var premCaption = root.querySelector("[data-de='premier-total-caption']");
    var premInfo = root.querySelector("[data-de='premier-info']");
    var stairsNote = root.querySelector("[data-de='stairs-note']");

    function onSubmit(e) {
      e.preventDefault();

      // Reset
      if (errBox) errBox.style.display = "none";
      if (grid) grid.style.display = "none";
      if (meta) meta.style.display = "none";
      if (noteStd) noteStd.style.display = "none";
      if (notePre) notePre.style.display = "none";
      if (premCaption) premCaption.style.display = "none";
      if (stairsNote) stairsNote.style.display = "none";

      var value = (input && input.value) || "";
      var up = value.toUpperCase().trim();
      var prefix = outwardPrefix(up);
      var oc = outward(up);

      // Validate
      if (!validUK(up)) {
        if (errTxt) errTxt.textContent = "Please enter a valid UK postcode (e.g., SW1A 1AA).";
        if (errBox) errBox.style.display = "block";
        return;
      }

      // Check for general exclusions first
      if (EXCLUDED_PREFIXES.indexOf(prefix) >= 0) {
        if (errTxt) {
          errTxt.textContent =
"Delivery Unavailable in Your Area\n\nWe're sorry, but your delivery postcode is currently not supported by our delivery network or appointed couriers. Unfortunately, this means we're unable to offer delivery to your area at the moment.\n\nWe understand this is disappointing, and we're continuously working to expand our delivery coverage. Please check back soon or contact our team for more information.";
        }
        if (errBox) errBox.style.display = "block";
        return;
      }

      // Check for Isle of Wight exclusions
      if (EXCLUDED_OUTWARD_CODES.indexOf(oc) >= 0) {
        if (errTxt) {
          errTxt.textContent =
"Delivery Unavailable to Isle of Wight\n\nWe're sorry, but we currently don't deliver to the Isle of Wight (PO30-PO41 postcodes). This is due to logistics constraints with our current delivery network.\n\nWe understand this is disappointing, and we're working to expand our coverage. Please contact our team for alternative arrangements or check back in the future.";
        }
        if (errBox) errBox.style.display = "block";
        return;
      }

      // Pricing + window
      var priceWin = getPriceWindowFor(up); // { price, d1, d2, bucket }
      if (!priceWin) {
        // This shouldn't happen now since we handle exclusions above, but keeping as failsafe
        if (errTxt) {
          errTxt.textContent = "Delivery unavailable to this postcode area.";
        }
        if (errBox) errBox.style.display = "block";
        return;
      }

      var inM25 = insideM25(up);

      // Meta
      if (pcTag) pcTag.textContent = up + " (" + oc + ")";
      if (meta) meta.style.display = "flex";

      // Premier total = Standard + £49.99
      var standardPrice = priceWin.price;
      var PREMIER_BASE = 49.99;
      var premierTotal = (standardPrice > 0) ? (standardPrice + PREMIER_BASE) : PREMIER_BASE;

      // Badges
      if (badgeStd) {
        badgeStd.textContent = standardPrice > 0 ? formatPrice(standardPrice) : "FREE";
        badgeStd.className = "de-badge" + (standardPrice === 0 ? " free" : "");
      }
      if (badgePre) {
        badgePre.textContent = formatPrice(premierTotal);
        badgePre.setAttribute(
          "title",
          standardPrice > 0
            ? "Premier total = £49.99 + Standard " + formatPrice(standardPrice)
            : "Premier total = £49.99 (Standard FREE)"
        );
      }

      // Premier caption (paid only)
      if (premCaption) {
        if (standardPrice > 0) {
          premCaption.textContent = "Total = " + formatPrice(standardPrice) + " + £49.99 Premier = " + formatPrice(premierTotal);
          premCaption.style.display = "block";
        } else {
          premCaption.style.display = "none";
        }
      }

      // Dates
      var estimateText;
      if (inM25) {
        var pair = nextTwoSundaysWithCutoff(new Date());
        estimateText = formatUK(pair.firstSunday) + " or " + formatUK(pair.secondSunday);
        if (stdRange) stdRange.textContent = estimateText;
        if (preRange) preRange.textContent = estimateText;
        if (noteStd) { noteStd.className = "de-note m25"; noteStd.style.display = "block"; }
        if (notePre) { notePre.className = "de-note m25"; notePre.style.display = "block"; }
      } else {
        // Free areas outside M25 must always show 2–7 working days
        var d1 = (standardPrice === 0) ? 2 : priceWin.d1;
        var d2 = (standardPrice === 0) ? 7 : priceWin.d2;
        estimateText = workingDateRangeText(d1, d2) + " (" + d1 + "–" + d2 + " working days)";
        if (stdRange) stdRange.textContent = estimateText;
        if (preRange) preRange.textContent = estimateText;
        if (noteStd) { noteStd.className = "de-note std"; noteStd.style.display = "block"; }
        if (notePre) { notePre.className = "de-note std"; notePre.style.display = "block"; }
      }

      // Show results
      if (grid) grid.style.display = "grid";
      if (stairsNote) stairsNote.style.display = "block";
    }

    function bind(){ if (form) form.addEventListener("submit", onSubmit); }
    function unbind(){ if (form) form.removeEventListener("submit", onSubmit); }

    bind();
    window.__DE_INSTANCES__[sid] = { root: root, unbind: unbind };
    return window.__DE_INSTANCES__[sid];
  }

  // Public API + auto-boot
  window.DeliveryEstimator = window.DeliveryEstimator || {
    init: initDeliveryEstimator,
    destroy: function (sid) {
      var inst = window.__DE_INSTANCES__ && window.__DE_INSTANCES__[sid];
      if (inst) { inst.unbind(); delete window.__DE_INSTANCES__[sid]; }
    },
    bootAll: function () {
      var nodes = document.querySelectorAll("[data-de-root][data-de-sid]");
      for (var i = 0; i < nodes.length; i++) {
        try { initDeliveryEstimator(nodes[i]); } catch (e) {}
      }
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function(){ window.DeliveryEstimator.bootAll(); });
  } else {
    window.DeliveryEstimator.bootAll();
  }

  // Theme Editor events (patched '&&')
  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target && event.target.querySelector("[data-de-root][data-de-sid]");
    if (root) window.DeliveryEstimator.init(root);
  });
  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target && event.target.querySelector("[data-de-root][data-de-sid]");
    if (root) {
      var sid = root.getAttribute("data-de-sid");
      if (sid) window.DeliveryEstimator.destroy(sid);
    }
  });
})();
